import { defineStore } from 'pinia';

export interface Notification {
  id: string;
  message: string;
}

function load(): Notification[] {
  try {
    return JSON.parse(localStorage.getItem('notifications') || '[]');
  } catch {
    return [];
  }
}

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    items: load() as Notification[]
  }),
  actions: {
    add(notification: Notification) {
      if (!this.items.find(n => n.id === notification.id)) {
        this.items.push(notification);
        localStorage.setItem('notifications', JSON.stringify(this.items));
      }
    },
    remove(id: string) {
      this.items = this.items.filter(n => n.id !== id);
      localStorage.setItem('notifications', JSON.stringify(this.items));
    },
    clear() {
      this.items = [];
      localStorage.removeItem('notifications');
    }
  }
});
